import * as Sentry from "@sentry/remix";
import { useEffect } from "react";
import { useLocation, useMatches } from "react-router";

const { PROD: IS_PROD, VITE_DEPLOYMENT_ENVIRONMENT } = import.meta.env;

const sentrySingleton = (() => {
  const globalScope = globalThis as typeof globalThis & {
    __worshipDevoSentry?: {
      initialized: boolean;
      replayIntegration: ReturnType<typeof Sentry.replayIntegration>;
    };
  };

  if (!globalScope.__worshipDevoSentry) {
    globalScope.__worshipDevoSentry = {
      initialized: false,
      replayIntegration: Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
        blockAllMedia: true,
      }),
    };
  }

  return globalScope.__worshipDevoSentry;
})();

export function initializeSentry(): void {
  if (sentrySingleton.initialized) {
    return;
  }

  Sentry.init({
    dsn: "https://fc900be59f93bdbe099359223cd9e434@o4507935725780992.ingest.us.sentry.io/4508258473541632",
    enabled: IS_PROD,
    environment: VITE_DEPLOYMENT_ENVIRONMENT,

    integrations: [
      Sentry.browserTracingIntegration({
        useEffect,
        useLocation,
        useMatches,
      }),
      sentrySingleton.replayIntegration,
    ],

    tracesSampler: ({ name }) => {
      if (name.includes("healthcheck")) {
        return 0;
      }

      return 0.5;
    },

    tracesSampleRate: 0.25,
    profilesSampleRate: 0.5,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1,
  });

  sentrySingleton.initialized = true;
}
